import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {Box, Divider, Typography} from '@mui/material';

import Logo from '../Logo/Logo.jsx';

export const ProductTitle = ({divider, logo, title}) => {
  return (
    <Box display="flex" alignItems="center">
      {logo || <Logo mark={!!title} styles={{height: title ? 20 : 30}} />}
      {divider && (
        <Divider
          orientation="vertical"
          flexItem
          sx={{marginX: 1, marginY: 0.25, borderColor: 'inherit'}}
        />
      )}
      <Typography variant="overline" fontWeight={600}>
        {title}
      </Typography>
    </Box>
  );
};

ProductTitle.propTypes = {
  divider: PropTypes.bool,
  logo: PropTypes.node,
  title: PropTypes.string,
};

export default memo(ProductTitle);
